// Bearer token storage. The legacy key is migrated once so existing sessions survive the rename.
const KEY = "videra_token";
const LEGACY_KEY = "harmony_token";

export const getToken = () => {
  const legacy = localStorage.getItem(LEGACY_KEY);
  if (legacy) {
    localStorage.setItem(KEY, legacy);
    localStorage.removeItem(LEGACY_KEY);
  }
  return localStorage.getItem(KEY);
};

export const setToken = (token) => localStorage.setItem(KEY, token);

export const clearToken = () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
};
